import { useMutation } from '@apollo/client';

import { StaffLeaveEventInput } from '../../apollo/__generated__/graphql';
import { STAFF_LEAVE_EVENT } from '../graphql/mutation/staffLeaveEventMutation.graphql';
import { ADMIN_EVENT_USERS } from '../graphql/query/adminEventUsersQuery.graphql';

export const useStaffLeaveEventMutation = () => {
  const [mutate] = useMutation(STAFF_LEAVE_EVENT);

  const staffLeaveEvent = (staffLeaveEventInput: StaffLeaveEventInput) => {
    mutate({
      variables: {
        staffLeaveEventInput,
      },
      refetchQueries: [ADMIN_EVENT_USERS],
    });
  };

  return { staffLeaveEvent };
};
